import React from 'react';

import { createDashboardPageClassName } from './dashboardPageStyles';

export const DashboardPageWrapper: React.FC = ({ children }) => (
  <div className={createDashboardPageClassName('wrapper')}>{children}</div>
);
